import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import axiosInstance from '../axios/axiosConfig';
import { buildAssemblyChangeLogEntry } from '../components/AssemblyPage/assemblyScheduleChangeLogUtils';

const useAssemblyScheduleChangeLog = () => {
  const apiUrls = useSelector((state) => state.apiUrls.urls);
  const userDetails = useSelector((state) => state.user.userDetails);
  const userRoles = useSelector((state) => state.user.userRoles);
  const currentUser = userDetails?.name || 'Unknown';
  const primaryRole = userRoles?.length > 0 ? userRoles[0] : 'User';

  const logAssemblyScheduleChange = useCallback(async (
    projectId,
    jobNumber,
    jobName,
    field,
    previousValue,
    newValue
  ) => {
    if (!apiUrls.assemblyScheduleChangeLog) {
      console.error('assemblyScheduleChangeLog API URL is not defined');
      return undefined;
    }

    const changeData = buildAssemblyChangeLogEntry({
      projectId,
      jobNumber,
      jobName,
      currentUser,
      userRole: primaryRole,
      field,
      previousValue,
      newValue,
    });

    try {
      const response = await axiosInstance.post(apiUrls.assemblyScheduleChangeLog, changeData);
      return response.data;
    } catch (error) {
      console.error('Error logging assembly schedule change:', error);
      return undefined;
    }
  }, [apiUrls.assemblyScheduleChangeLog, currentUser, primaryRole]);

  return { logAssemblyScheduleChange };
};

export default useAssemblyScheduleChangeLog;
